import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-erreur',
    templateUrl: './erreur.component.html',
    styleUrls: ['./erreur.component.scss']
})
export class ErreurComponent implements OnInit {

    protected errorNumber : string | null ='';

    constructor(private route : ActivatedRoute) {
    }

    ngOnInit(): void {
        this.errorNumber = this.route.snapshot.paramMap.get('status');
    }

}
